

(function ($) {
  "use strict";
  init();

})(jQuery);

function init() {

}
